import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card shadow-sm" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "payment-info mb-4 p-3 bg-light rounded" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { class: "payment-methods" }
const _hoisted_11 = { class: "method-check" }
const _hoisted_12 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_13 = { class: "method-check" }
const _hoisted_14 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_15 = { class: "method-check" }
const _hoisted_16 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_17 = { class: "d-flex gap-3 mt-4" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, [
        _createElementVNode("h4", { class: "mb-0" }, [
          _createElementVNode("i", { class: "flaticon-payment me-2" }),
          _createTextVNode(" Choisir un moyen de paiement ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "spinner-border text-primary" }, null, -1),
              _createElementVNode("p", { class: "mt-3" }, "Chargement...", -1)
            ]))]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Détails du paiement", -1)),
                  _createElementVNode("p", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Référence BESC:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.refbesc), 1)
                  ]),
                  _createElementVNode("p", _hoisted_9, [
                    _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Montant:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.amount)) + " FCFA", 1)
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "mb-3" }, "Sélectionnez votre méthode de paiement", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["payment-method-card", { 'selected': _ctx.selectedMethod === 'kkiapay' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMethod('kkiapay')))
                  }, [
                    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"method-icon\" data-v-6cb631fa><i class=\"fas fa-mobile-alt\" style=\"font-size:50px;color:#00c853;\" data-v-6cb631fa></i></div><div class=\"method-info\" data-v-6cb631fa><h6 class=\"mb-1\" data-v-6cb631fa>Mobile Money / Carte</h6><p class=\"text-muted small mb-0\" data-v-6cb631fa> MTN, Moov, Visa, Mastercard </p><span class=\"badge bg-success mt-1\" data-v-6cb631fa>Recommandé 🇧🇯</span></div>", 2)),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.selectedMethod === 'kkiapay')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["payment-method-card", { 'selected': _ctx.selectedMethod === 'paypal' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMethod('paypal')))
                  }, [
                    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"method-icon\" data-v-6cb631fa><i class=\"fab fa-paypal\" style=\"font-size:50px;color:#0070ba;\" data-v-6cb631fa></i></div><div class=\"method-info\" data-v-6cb631fa><h6 class=\"mb-1\" data-v-6cb631fa>PayPal</h6><p class=\"text-muted small mb-0\" data-v-6cb631fa> Payez avec votre compte PayPal </p></div>", 2)),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.selectedMethod === 'paypal')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["payment-method-card", { 'selected': _ctx.selectedMethod === 'stripe' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectMethod('stripe')))
                  }, [
                    _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"method-icon\" data-v-6cb631fa><i class=\"fab fa-cc-stripe\" style=\"font-size:50px;color:#635bff;\" data-v-6cb631fa></i></div><div class=\"method-info\" data-v-6cb631fa><h6 class=\"mb-1\" data-v-6cb631fa>Carte Bancaire Internationale</h6><p class=\"text-muted small mb-0\" data-v-6cb631fa> Visa, Mastercard, American Express </p></div>", 2)),
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.selectedMethod === 'stripe')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "btn btn-primary flex-grow-1",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.proceedToPayment && _ctx.proceedToPayment(...args))),
                    disabled: !_ctx.selectedMethod || _ctx.processing
                  }, [
                    (_ctx.processing)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.processing ? 'Redirection...' : 'Continuer vers le paiement'), 1)
                  ], 8, _hoisted_18),
                  _createVNode(_component_router_link, {
                    to: "/liste-besc",
                    class: "btn btn-outline-secondary"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode(" Annuler ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
      ])
    ])
  ]))
}